import { h } from 'preact'; /** @jsx h */

import './Hero.scss';

const Hero = ({ imageSrc, alt, children }) => {
    return (
        <section className="hero">
            <div className="hero-image" style={{ backgroundImage: `url(${imageSrc})` }} />
            <div className="hero-content">{children}</div>
        </section>
    );
};

export default Hero;
